document.addEventListener('DOMContentLoaded', () => {

  const FREE_FEEDER_ID = 53802997842267;
  const OFFER_FONDANT_ID = 53803041259867;

  const SYRUP_HANDLE =
    'invertbee-syrup-14kg-10l-ready-to-use-liquid-bee-feed-spring-bee-syrup';

  let checking = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not check basket.');
    }

    return response.json();
  }


  async function setQuantity(lineKey, quantity) {

    const response = await fetch('/cart/change.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })

    });

    if (!response.ok) {
      throw new Error(
        'Could not update the weekly offer.'
      );
    }

    return response.json();
  }


  function getSyrupQuantity(cart) {

    return cart.items
      .filter(
        item => item.handle === SYRUP_HANDLE
      )
      .reduce(
        (total, item) =>
          total + item.quantity,
        0
      );

  }


  function getOfferFondantQuantity(cart) {

    return cart.items
      .filter(
        item =>
          Number(item.variant_id) ===
          OFFER_FONDANT_ID
      )
      .reduce(
        (total, item) =>
          total + item.quantity,
        0
      );

  }


  function getFreeFeederQuantity(cart) {

    return cart.items
      .filter(
        item =>
          Number(item.variant_id) ===
          FREE_FEEDER_ID
      )
      .reduce(
        (total, item) =>
          total + item.quantity,
        0
      );

  }


  async function checkOffer() {

    if (checking) return;

    checking = true;

    try {

      const cart = await getCart();

      const syrupQuantity =
        getSyrupQuantity(cart);

      const offerFondantQuantity =
        getOfferFondantQuantity(cart);

      const freeFeederQuantity =
        getFreeFeederQuantity(cart);


      /*
       * Number of complete £53.99 offers
       * the customer is entitled to.
       */
      const allowedOffers = Math.min(
        syrupQuantity,
        offerFondantQuantity
      );


      /*
       * Find the promotional product lines.
       */
      const offerFondantLines =
        cart.items.filter(
          item =>
            Number(item.variant_id) ===
            OFFER_FONDANT_ID
        );

      const freeFeederLines =
        cart.items.filter(
          item =>
            Number(item.variant_id) ===
            FREE_FEEDER_ID
        );


      /*
       * They cannot have more discounted
       * fondant than they have syrup.
       */
      if (
        offerFondantQuantity >
        syrupQuantity
      ) {

        let remaining = syrupQuantity;

        for (
          const line of offerFondantLines
        ) {

          const keep =
            Math.min(
              line.quantity,
              remaining
            );

          remaining -= keep;

          if (line.quantity !== keep) {

            await setQuantity(
              line.key,
              keep
            );

          }

        }

        window.location.reload();
        return;
      }


      /*
       * They cannot have more FREE feeders
       * than complete syrup + offer-fondant
       * combinations.
       */
      if (
        freeFeederQuantity >
        allowedOffers
      ) {

        let remaining = allowedOffers;

        for (
          const line of freeFeederLines
        ) {

          const keep =
            Math.min(
              line.quantity,
              remaining
            );

          remaining -= keep;

          if (line.quantity !== keep) {

            await setQuantity(
              line.key,
              keep
            );

          }

        }

        window.location.reload();
        return;
      }


    } catch (error) {

      console.error(
        'AGS feed offer protection:',
        error
      );

    } finally {

      checking = false;

    }

  }


  /*
   * Check the basket when it loads.
   */
  if (
    window.location.pathname === '/cart'
  ) {

    setTimeout(
      checkOffer,
      600
    );

  }


  /*
   * Check after +/- or remove is clicked.
   */
  document.addEventListener(
    'click',
    event => {

      if (
        event.target.closest(
          '.quantity__button'
        ) ||
        event.target.closest(
          'cart-remove-button'
        )
      ) {

        setTimeout(
          checkOffer,
          1000
        );

      }

    }
  );


  /*
   * Check manually entered quantities.
   */
  document.addEventListener(
    'change',
    event => {

      if (
        event.target.matches(
          'input[name="updates[]"]'
        )
      ) {

        setTimeout(
          checkOffer,
          1000
        );

      }

    }
  );

});